import { render, staticRenderFns } from "./putongReport.vue?vue&type=template&id=dbb31c02&scoped=true"
import script from "./putongReport.vue?vue&type=script&lang=js"
export * from "./putongReport.vue?vue&type=script&lang=js"
import style0 from "./putongReport.vue?vue&type=style&index=0&id=dbb31c02&prod&scoped=true&lang=less"
import style1 from "./putongReport.vue?vue&type=style&index=1&id=dbb31c02&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb31c02",
  null
  
)

export default component.exports